import React from 'react'
import styled from 'styled-components'
import { createResource, useResource } from '@/lib/i18n'
import Image from 'next/image'
import { useWindowSize } from '@/lib/use-hooks/use-window-size'
import { eventLogProducer } from '@/lib/event-logger'
import { Action } from '@@/action_pb'
import { playPath, shimmer, toBase64 } from '@/lib/utils'
import { IDownloadType, ILocation } from '@/lib/enums/device'
import IosDownloadBtn from '../common/ios-download-btn'
import LazyLoad from 'react-lazyload'

const resource = createResource({
  en: {
    title: 'Get cash loan with 2, 3, 6 and 12 months of installment NOW!',
  },
  id: {
    title: 'Dapatkan pinjaman tunai dengan cicilan 2, 3, 6 dan 12 bulan SEKARANG!',
  },
})

const FAQFollow = () => {
  const { width } = useWindowSize()
  const isMobile = width < 1000
  const { t } = useResource(resource)
  const eventClick = () => {
    eventLogProducer.push({
      action: Action.GETITONGOOGLEPLAYBUTTONCLICK,
    })
  }
  const goToDown = (herf: string) => {
    eventLogProducer.push({
      action: Action.GETITONAPPGALLERYBUTTONCLICK,
    })
    setTimeout(() => {
      window.open(herf)
    }, 1000)
  }

  return (
    <FollowBox>
      <div className="container">
        <h1 className="title">{t('title')}</h1>
        <section className="banner-out">
          {width > 1000 ? (
            <div className="google-play">
              <section
                className="banner goto"
                onClick={() => goToDown(playPath(IDownloadType.GOOGLE_PLAY, '', ILocation.FAQ))}
              >
                <img className="qrcode" src="/images/qrcode/qr_faq.png" alt="qrcode" />
                <LazyLoad>
                  <Image
                    src="/images/home/google_play.png"
                    alt="google_play"
                    width={217}
                    height={66}
                    quality={85}
                    placeholder="blur"
                    blurDataURL={`data:image/svg+xml;base64,${toBase64(shimmer(217, 66))}`}
                  />
                </LazyLoad>
              </section>
              <div className="self-down">
                <IosDownloadBtn location={ILocation.FAQ} isMobile={isMobile} />
              </div>
            </div>
          ) : (
            <div>
              <a
                href={playPath(IDownloadType.GOOGLE_PLAY, '', ILocation.FAQ)}
                rel="noopener noreferrer nofollow"
                target="_blank"
                className="google_play"
                onClick={() => eventClick()}
              >
                <LazyLoad>
                  <Image
                    src="/images/qrcode/edu_google_mb.png"
                    alt="google_play"
                    width={130}
                    height={41}
                    placeholder="empty"
                    quality={85}
                  />
                </LazyLoad>
              </a>
              <div className="self-down">
                <IosDownloadBtn location={ILocation.FAQ} isMobile={isMobile} />
              </div>
            </div>
          )}
        </section>
      </div>
    </FollowBox>
  )
}

export default FAQFollow

const FollowBox = styled.div`
  @media only screen and (max-width: 1000px) {
    padding-top: 62px;
    .container {
      width: 100%;
      margin: 0 auto;
      height: 461px;
      padding: 43px 24px 185px;
      background-image: url('/images/faq/m-faq-banner.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .title {
        margin: 0 0 24px;
        font-family: Roboto;
        font-size: 28px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
        color: rgba(0, 0, 0, 0.87);
      }
      .google-play {
        width: 130px;
        height: 41px;
      }
      a {
        width: 130px;
        height: 41px;
        display: inline-block;
      }
      .banner {
        display: flex;
        justify-content: flex-start;
        width: 130px;
        height: 41px;
        .qrcode {
          display: none;
        }
      }
      .self-down {
        margin-top: 10px !important;
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    max-width: 1440px;
    margin: 100px auto 0;
    .container {
      background-image: url('/images/faq/faq-banner.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      height: 480px;
      padding: 80px 150px 110px;
      width: 100%;
      max-width: 1440px;
      display: flex;
      flex-direction: column;
      text-align: center;
      .title {
        width: 56%;
        text-align: left;
        height: 204px;
        margin: 0 0 32px;
        font-family: Roboto;
        font-size: 44px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.55;
        letter-spacing: normal;
        color: rgba(0, 0, 0, 0.87);
      }
      .google-play {
        display: flex;
        margin-top: 50px;
        .goto {
          cursor: pointer;
        }
        .banner {
          position: relative;
          width: 217px;
          height: 66px;
          box-sizing: border-box;
          .qrcode {
            position: absolute;
            top: 50%;
            right: 0;
            transform: translateY(-50%);
            width: 100%;
            height: 100%;
            z-index: 1;
            opacity: 0;
          }
        }
        .banner:hover .qrcode {
          top: 140px;
          width: 160px;
          height: 160px;
          border-radius: 8px;
          background: #fff;
          box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.1);
          border: 1px solid #f5f5f5;
          opacity: 1;
          z-index: 3;
        }
        .self-down {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 24px;
          .apk_text {
            position: absolute;
            font-size: 16px;
            font-family: Roboto-Medium, Roboto;
            font-weight: 500;
            color: #fff;
            letter-spacing: -0.6px;
            line-height: 19px;
            width: 58%;
            padding-left: 8px;
            z-index: 1;
          }
        }
      }
    }
  }
`
